import React, {PropTypes} from 'react';
import RaisedButton from 'material-ui/RaisedButton';
import RichEditor from '../../form/RichEditor';
import Input from '../../form/Input';
import InputToggle from '../../form/InputToggle';
import FullDatePicker from '../../form/FullDatePicker';
import {Container, Row, Col} from 'react-grid-system'
import ProductSelect from '../../Shop/ProductSelect';
import ConfirmMessage from '../../ConfirmMessage';
import AbstractEditForm from '../../common/AbstractEditForm';

class PromotionEditForm extends AbstractEditForm {
  static propTypes = {
    ...AbstractEditForm.propTypes,
    isDisabledSelectProduct: PropTypes.bool.isRequired,
    disabled: PropTypes.bool,
    isPublished: PropTypes.bool,
    publish: PropTypes.func.isRequired
  };

  state = {
    newProduct: null,
    showConfirmMessage: false
  };

  changeProduct = (newProduct) => {
    let {product, description} = this.props.fields;
    product.onChange(newProduct);
    description.onChange(`<h1>${newProduct.name}</h1>`);
  };

  updateProduct = (newProduct) => {
    if (!this.props.fields.product.value || this.props.fields.product.value === null) {
      this.changeProduct(newProduct);
    } else if (this.props.fields.product.value.id !== newProduct.id) {
      this.setState({
        newProduct,
        showConfirmMessage: true
      });
    }
  };

  closeConfirmWindow = () => {
    this.setState({
      newProduct: null,
      showConfirmMessage: false
    });
  };

  _publish = () => {
    return async () => {
      await this.publish();
      await this.goBack();
    }
  };

  render() {
    let {
      isDisabledSelectProduct,
      isPublished,
      disabled,
      pristine,
      fields: {
        expiredDate,
        product,
        title,
        description,
        vip
      },
      valid,
      submitting
    } = this.props;

    let {showConfirmMessage} = this.state;

    return (
      <form onSubmit={this.processSubmit} style={{padding: 16}}>
        {this._renderHeader()}

        <Container style={{marginLeft: 0}}>
          <Row>
            <Col lg={8} md={10} xs={12}>
              <Row>
                <Col xs={12}>
                  <InputToggle label='VIP only'
                               disabled={isPublished || disabled}
                               required {...vip}/>
                </Col>

                <Col xs={12}>
                  <ProductSelect label='Add the promotion product' required
                                 disabled={isDisabledSelectProduct || disabled} {...product}
                                 onChange={this.updateProduct}/>
                </Col>
                <Col xs={12}>
                  <Input label='Title' required  {...title} disabled={disabled}/>
                </Col>

                <Col xs={12}>
                  <RichEditor label='Content' required  {...description} disabled={disabled}/>
                </Col>

                <Col xs={12}>
                  <FullDatePicker label='Expires on' min={new Date()} {...expiredDate} disabled={disabled}/>
                </Col>

                <Col xs={6}>
                  <RaisedButton secondary={true}
                                fullWidth={true}
                                disabled={!valid || submitting || isPublished || disabled || pristine}
                                onClick={this.processSubmit}
                                label='Save'/>
                </Col>
                <Col xs={6}>
                  <RaisedButton primary={true}
                                fullWidth={true}
                                disabled={!valid || submitting || isPublished || disabled}
                                onClick={this._publish()}
                                label='Save and Publish'/>
                </Col>
              </Row>
            </Col>
          </Row>
        </Container>
        {
          showConfirmMessage
            ? (<ConfirmMessage
            open={showConfirmMessage}
            message='The description of promotion will change. Do you want change product?'
            onConfirm={() => this.changeProduct(this.state.newProduct)}
            onClose={this.closeConfirmWindow}
          />)
            : null
        }
      </form>
    );
  }
}

export default PromotionEditForm;



// WEBPACK FOOTER //
// ./src/components/Promotions/PromotionEditForm/PromotionEditForm.jsx